import request from '../../axios';

export const postCheckOtpCode = async (payload: IPostCheckOtpCode) => {
  await request.post(`/api/v2/payment/validate-etebarito-otp`, payload);
};
